export function resolveBrowserCompletionTimeZone(intl = Intl) {
  try {
    const timeZone = intl.DateTimeFormat().resolvedOptions().timeZone;
    return typeof timeZone === "string" && timeZone.trim() ? timeZone : null;
  } catch {
    return null;
  }
}
